import React, { Component } from "react";
import ReactDOM from "react-dom";
import Advert from "../Advert";
import AppearanceSwitch from "./AppearanceSwitch";
import { Scrollbars } from "react-custom-scrollbars";
import Sites from "../Sites";
import Nav from "../Nav";
import "whatwg-fetch";
import defaultProfilePic from "../../img/default_profilepic.png";

class Menu extends Component {
  constructor() {
    super();
    this.state = {
      list: [],
      footer_menu: [],
    };

    this.subCatMenuToggle = this.subCatMenuToggle.bind(this);
    this.menuToggle = this.menuToggle.bind(this);
    this.getMenu = this.getMenu.bind(this);
  }

  getMenu() {
    const { theme } = this.props;
    let that = this;

    if (document.getElementById("static-ads-leaderboard")) {
      ReactDOM.render(
        <Advert theme={theme} position="firstLeaderboard" />,
        document.getElementById("static-ads-leaderboard")
      );
    }

    if (document.getElementById("static-ads-lrec")) {
      ReactDOM.render(
        <div className="ad_300x250 text-center">
          <Advert theme={theme} position="firstMediumRectangle" />
        </div>,
        document.getElementById("static-ads-lrec")
      );
    }
    fetch("/asset/" + theme + "/menu.json?t=" + new Date().getTime(), {
      method: "GET",
    })
      .then(function(res) {
        return res.json();
      })
      .then(function(response) {
        let arr = response.items.main_menu;
        let footer_menu_arr = response.items.footer_menu;
        let social_menu_arr = response.items.social;
        that.setState({
          list: arr,
          footer_menu: footer_menu_arr,
          social_menu: social_menu_arr,
        });
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  componentDidMount() {
    this.getMenu();
  }

  mainMenuToggle(evnt) {}

  menuToggle(evnt) {
    if (document.getElementById("menu-nav")) {
      let elm = document.getElementById("menu-nav");
      if (elm.className.indexOf("open") !== -1) {
        document.getElementById("menu-nav").className = "";
      }
    }
  }

  subCatMenuToggle(evnt) {
    if (document.querySelectorAll(".sub-cat-menu.parent.open").length) {
      let elm = document.querySelectorAll(".sub-cat-menu.parent.open")[0];
      elm.className = elm.className.replace("open", "");
    } else {
      let dataset = evnt.currentTarget.dataset;

      let elm = document.getElementById(dataset.subcategory + "-subcat");
      if (elm.className.indexOf("open") < 0) {
        elm.className = elm.className + "open";
      }
    }
  }

  renderLogin() {
    const { baseurl, theme } = this.props;
    let memberCenter = JSON.parse(
      document.querySelector('meta[name="memberCenter"]').content
    );
    let memberInfo =
      document.querySelector('meta[name="memberInfo"]').content == ""
        ? ""
        : JSON.parse(document.querySelector('meta[name="memberInfo"]').content);
    let tmpHTML = "";
    let tmpURL =
      theme.indexOf("blog.she.com") == -1
        ? memberCenter.profileUrl
        : baseurl + "/wp-login.php";

    let shelogoPath = "/assets-2021/img/she-logo.png";
    switch (theme) {
      case "she.com": {
        shelogoPath = "/assets-2021/img/she-logo.png";
        break;
      }
      case "shemom.com": {
        shelogoPath = "/assets-2021/img/icon-new-shemom.svg";
        break;
      }
      case "brides.she.com": {
        shelogoPath = "/assets-2021/img/icon-new-shebrides.svg";
        break;
      }
      default: {
        shelogoPath = "/assets-2021/img/she-logo.png";
        break;
      }
    }

    if (memberInfo == "") {
      tmpHTML = (
        <div className="clearfix">
          <div className="profile-pic">
            <a href="/">
              <img className="she-logo" src={shelogoPath} alt="profile" />
            </a>
          </div>
          <div className="profile-pic">
            <img src="/assets-2021/img/default_profilepic.png" alt="profile" />
          </div>
          <a className="login-button" href={memberCenter.signinUrl}>
            login
          </a>
        </div>
      );
    } else {
      tmpHTML = (
        <div className="clearfix">
          <div className="profile-pic she-logo">
            <a href="/">
              <img className="she-logo" src={shelogoPath} alt="profile" />
            </a>
          </div>
          <div className="profile-pic">
            <a href={tmpURL}>
              <img src={memberInfo.profile_image} alt="profile" />
            </a>
          </div>
          <div className="profile-info">
            <a className="username Abel" href={tmpURL}>
              {"Hello " + memberInfo.username}
            </a>
            <a className="login-button log-out" href={memberCenter.logoutUrl}>
              logout
            </a>
          </div>
        </div>
      );
    }

    return tmpHTML;
  }

  footerItemPlaceholder() {
    const reminder = this.state.footer_menu.length % 3;
    const list = [];

    if (reminder === 2) {
      list.push(<a className={"footer-item"} />);
    }
    return list;
  }

  render() {
    const { list, footer_menu, social_menu } = this.state;
    const { baseurl, theme } = this.props;
    let that = this;

    console.log("list: ", list);

    if (list.length) {
      return (
        <div id="menu-nav">
          <Scrollbars>
            <div id="login-block">{this.renderLogin()}</div>

            <div className="btn-close text-right">
              <img
                className="menu-close"
                src={"/assets-2021/img/menu-close.svg"}
                alt="menu close"
                onClick={this.menuToggle}
              />
            </div>
            <div className={"menu-item-container"}>
              {list.map(function(item, index) {
                if (item.title === "shepromotes") {
                  return (
                    <div key={index} className={"menu-item-wrapper"}>
                      <div
                        className={"menu-item-placeholder"}
                        style={{ backgroundColor: "#000" }}
                      />
                      <a className="new-menu-item shepromotes" href={item.url}>
                        {item.title}
                        <div>member benefit</div>
                      </a>
                    </div>
                  );
                } else {
                  return (
                    <div key={index} className={"menu-item-wrapper"}>
                      <div
                        className={"menu-item-placeholder"}
                        style={{
                          backgroundColor: item.menu_color
                            ? item.menu_color
                            : "#000",
                        }}
                      />
                      <a className="new-menu-item" href={item.url}>
                        {item.title}
                      </a>
                    </div>
                  );
                }
              })}
            </div>

            <div className="sites-container">
              <Sites theme={theme} />
              <div id="sns" className="clearfix">
                <div className="findus-wrapper">
                  <hr className="findus-stroke" />
                  <div className="findus">find us on</div>
                  <hr className="findus-stroke" />
                </div>

                <div className="social-media-container">
                  <a
                    href={social_menu.facebook}
                    title="facebook"
                    target="blank"
                  >
                    <img
                      className="social-media-icon"
                      src={"/assets-2021/img/icon-facebook.svg"}
                      alt={"facebook icon"}
                    />
                  </a>

                  <a
                    href={social_menu.instagram}
                    title="instagram"
                    target="blank"
                  >
                    <img
                      className="social-media-icon"
                      src={"/assets-2021/img/icon-ig.svg"}
                      alt={"instagram icon"}
                    />
                  </a>

                  <a href={social_menu.youtube} title="youtube" target="blank">
                    <img
                      className="social-media-icon"
                      src={"/assets-2021/img/icon-youtube.svg"}
                      alt={"youtube icon"}
                    />
                  </a>

                  <a href={social_menu.weibo} title="weibo" target="blank">
                    <img
                      className="social-media-icon"
                      src={"/assets-2021/img/icon-weibo.svg"}
                      alt={"weibo icon"}
                    />
                  </a>
                </div>
              </div>
            </div>

            {theme === "she.com" ? <AppearanceSwitch /> : null}

            <div id="footer-menu" style={{ borderTop: "1px solid #484848" }}>
              <div className={"footer-menu-item-container"}>
                {footer_menu.map(function(item, idx) {
                  const reminder = footer_menu.length % 3;

                  if (reminder === 1 && idx === footer_menu.length - 1) {
                    return (
                      <a
                        key={idx}
                        className={"footer-item single"}
                        href={item.url}
                      >
                        {item.title}
                      </a>
                    );
                  } else {
                    return (
                      <a key={idx} className={"footer-item"} href={item.url}>
                        {item.title}
                      </a>
                    );
                  }
                })}
                {this.footerItemPlaceholder()}
              </div>

              <p className="copyright menu-info Abel">
                copyright © 2000-{new Date().getFullYear()} she communications
                limited. all rights reserved
              </p>
            </div>
          </Scrollbars>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Menu/index.js